export const calculateDiscountedPrice = (originalPrice, discountPercentage) => {
  if (!originalPrice || isNaN(originalPrice)) return 0;
  if (discountPercentage == null || isNaN(discountPercentage))
    return originalPrice;
  return originalPrice - (originalPrice * discountPercentage) / 100;
};
